// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"5c126584f4f308aca48b","263":"f15c623f58ab8fe6846e","264":"59716d3391431b168f47","317":"fc15f82151ea86219768"}[chunkId] + ".chunk.js";
};